import type { FC } from "react";

import { Field, FieldError, FieldLabel } from "@recobra/ui/field";
import { Input } from "@recobra/ui/input";

import { getErrorMessage, useFieldContext } from "./context";

export const CnhField: FC<{ label: string; id?: string }> = ({ label, id }) => {
  const field = useFieldContext<string | undefined>();
  const errorMessage = getErrorMessage(field.state.meta.errors[0]);

  return (
    <Field data-invalid={errorMessage ? "true" : undefined} className="min-w-0">
      <FieldLabel htmlFor={id}>{label}</FieldLabel>
      <Input
        id={id}
        value={field.state.value ?? ""}
        onChange={(e) => {
          const next = e.target.value.replace(/\D/g, "").slice(0, 11);
          field.handleChange(next || undefined);
        }}
        onBlur={field.handleBlur}
        inputMode="numeric"
        maxLength={11}
        aria-invalid={Boolean(errorMessage)}
      />
      {errorMessage ? <FieldError>{errorMessage}</FieldError> : null}
    </Field>
  );
};
